<template>
<div>

  <TtiHeader />

  <!-- Hero card -->
  <div class="relative">
    <!-- <div class="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" /> -->
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="relative sm:rounded-2xl sm:overflow-hidden">
        <div class="absolute inset-0">
          <video autoplay muted loop ref="video" poster="../assets/pexels-pavel-danilyuk-7352051.jpg" class="h-full w-full object-cover">
            <source src="../media/The Tutor Index Background 480p.mp4" />
          </video>
          <!-- <img class="h-full w-full object-cover" src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2830&q=80&sat=-100" alt="People working on laptops" /> -->
          <div class="absolute inset-0 bg-gray-200 mix-blend-saturation" />
          <div class="absolute inset-0 bg-blue-400 mix-blend-lighten opacity-40" />
        </div>
        <div class="relative z-10 px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8" style="background-image: linear-gradient(to bottom, transparent, rgba(0,0,0,0.3), transparent)">
          <h1 class="text-center text-5xl font-extrabold tracking-tight lg:text-6xl">
            <span class="block text-white">Unleash your</span>
            <span class="block text-white">full potential</span>
          </h1>
          <p class="mt-6 max-w-lg mx-auto text-center text-base text-light-blue-100 sm:max-w-3xl sm:text-lg lg:text-xl">
            Find your perfect match from our <br class="lg:hidden" /> range of expert, independent tutors.
          </p>
          <div class="mt-14  mx-auto max-w-md">
            <div class="flex justify-between items-center space-x-2 p-2 pl-4 bg-white rounded-md">
              <!-- <input placeholder="What would you like to learn?" class="flex-1 w-48 outline-none" /> -->
              <div class="flex-1 w-48">
                <VSelect
                  ref="initialbox"
                  v-model="initial"
                  :options="initialListItems"
                  label="Description"
                  @input="onInitialSelected"
                  @search="onInitialInput"
                  :clear-search-on-select="true"
                  placeholder="What would you like to learn?"
                  class="border-none outline-none homepage-search"
                >
                  <template #no-options="{ search }">
                    <span v-if="search">Sorry, no matching options.</span>
                    <span class="sr-only">{{ search }}</span>
                  </template>
                </VSelect>
              </div>
              <button type="button" class="flex-shrink-0 flex justify-center items-center w-10 h-10 bg-blue-600 rounded-md">
                <SearchIcon class="w-6 h-6 text-white" />
              </button>
            </div>
            <p class="mt-2 pl-4 text-light-blue-100 text-sm">
              <span class="hidden sm:inline">Popular: </span>
              <span class="sm:hidden">e.g. </span>
              <span
                v-for="(item, index) of popularSearches"
                :key="item.id"
              >
                <span v-if="index > 0">, </span>
                <button
                  @click="$router.push({ name: 'SearchResults', query: item.query })"
                  class="underline"
                >  
                  {{ item.label }}
                </button>
              </span>
            </p>
            <!-- <button
              @click="$refs.video.paused ? $refs.video.play() : $refs.video.pause()"
              class="absolute bottom-0 right-0"
            >
              {{ videoPaused }}
              <span v-if="$refs.video && $refs.video.paused">Play</span>
              <span v-else>Pause</span>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  



  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="relative bg-white pt-16 pb-32 overflow-hidden">
    <div class="relative">
      <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
          <div>
            <div>
              <span class="h-12 w-12 rounded-md flex items-center justify-center bg-blue-600">
                <img src="../assets/mug-hot-regular.svg" class="w-6 h-6 filter invert" />
              </span>
            </div>
            <div class="mt-6">
              <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                Learn in a way that suits you
              </h2>
              <p class="mt-4 text-lg text-gray-500">
                Fancy learning online, in your home, in a coffee shop? We’ve got you covered. Our tutors are not tied to a specific platform, online or face-to-face teaching, meaning you can find a tutor who best suits your needs.
              </p>
              <div class="mt-6">
                <button type="button" @click="focusOnSearch" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700">
                  Find a Tutor
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="mt-8 border-t border-gray-200 pt-6">
            <blockquote>
              <div>
                <p class="text-base text-gray-500">
                  &ldquo;Cras velit quis eros eget rhoncus lacus ultrices sed diam. Sit orci risus aenean curabitur donec aliquet. Mi venenatis in euismod ut.&rdquo;
                </p>
              </div>
              <footer class="mt-3">
                <div class="flex items-center space-x-3">
                  <div class="flex-shrink-0">
                    <img class="h-6 w-6 rounded-full" src="https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80" alt="" />
                  </div>
                  <div class="text-base font-medium text-gray-700">
                    Marcia Hill, Digital Marketing Manager
                  </div>
                </div>
              </footer>
            </blockquote>
          </div> -->
        </div>
        <div class="mx-auto -mt-20 max-w-md w-full sm:-mt-32 lg:-mt-20 lg:relative lg:h-full lg:max-w-none">
          <!-- <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="https://tailwindui.com/img/component-images/inbox-app-screenshot-1.jpg" alt="Inbox user interface" /> -->
          <CoffeeBreak />
        </div>
        
      </div>
    </div>
    <div class="mt-24 lg:mt-0">
      <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
          <div>
            <div>
              <span class="h-12 w-12 rounded-md flex items-center justify-center bg-blue-600">
                <CubeTransparentIcon class="h-6 w-6 text-white" aria-hidden="true" />
              </span>
            </div>
            <div class="mt-6">
              <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                Find a tutor that’s right for you
              </h2>
              <p class="mt-4 text-lg text-gray-500">
                We have tutors from all walks of life, with a wide range of skills and teaching styles. The perfect match might not be a practicing teacher or the most qualified but one similar in age or someone with whom you can develop real chemistry.
              </p>
              <div class="mt-6">
                <button type="button" @click="focusOnSearch" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700">
                  Get started
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-auto max-w-md w-full lg:relative lg:h-full lg:max-w-md">
          <!-- <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" src="https://tailwindui.com/img/component-images/inbox-app-screenshot-2.jpg" alt="Customer profile user interface" /> -->
          <InternationalCooperation />
        </div>
      </div>
    </div>
  </div>





  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="relative bg-gray-900">
    <div class="h-80 w-full absolute bottom-0 xl:inset-0 xl:h-full">
      <div class="h-full w-full xl:grid xl:grid-cols-2">
        <div class="h-full xl:relative xl:col-start-2">
          <img class="h-full w-full object-cover opacity-25 xl:absolute xl:inset-0" src="../assets/pexels-katerina-holmes-5905709.jpg" alt="Learning Online">
          <div aria-hidden="true" class="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"></div>
        </div>
      </div>
    </div>
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
      <div class="relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24">
        <h2 class="text-sm font-semibold text-indigo-300 tracking-wide uppercase">
          What makes our tutors special?
        </h2>
        <p class="mt-3 text-3xl font-extrabold text-white">The Tutor Index is <em>not</em> an agency</p>
        <p class="mt-5 text-lg text-gray-300">Our tutors are more than just educators, they are in charge of their own business, and the responsibilities that come with it. This means:</p>
        <div class="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2">
          <p>
            <span class="block text-2xl font-bold text-white">We put tutors back in control</span>
            <span class="mt-1 block text-base text-gray-300">Our tutors are all in control of their own business, deciding how, when, and where they teach, ensuring they feel empowered to provide the best service possible.</span>
          </p>
          
          <p>
            <span class="block text-2xl font-bold text-white">1-to-1 Communication</span>
            <span class="mt-1 block text-base text-gray-300">You can contact tutors here without restrictions. Talk to as many tutors as you like to find the right fit for you. Use our direct messaging service or to move the conversation to email, Zoom or a good old fashioned phone call. Whatever works best for you.</span>
          </p>

          <p>
            <span class="block text-2xl font-bold text-white">No Restrictions</span>
            <span class="mt-1 block text-base text-gray-300">We leave the teaching to the experts. Tutors on The Tutor Index can pass on their knowledge in whatever way they feel best suits you. The end result? The best possible learning experience.</span>
          </p>

          <p>
            <span class="block text-2xl font-bold text-white">Competitive Rates</span>
            <span class="mt-1 block text-base text-gray-300">Our tutors decide their own rates and don’t pay us any commissions or finders fees. No middlemen taking a cut means our tutors can charge a lower rate than elsewhere whilst taking home their fair share.</span>
          </p>

          <!-- <p>
            <span class="block text-2xl font-bold text-white">12M+</span>
            <span class="mt-1 block text-base text-gray-300"><span class="font-medium text-white">Issues resolved</span> lacus nibh integer quis.</span>
          </p> -->

          <div>
            <button type="button" @click="focusOnSearch" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700">
              Find my Perfect Tutor
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>



<!-- This example requires Tailwind CSS v2.0+ -->
<div class="bg-gray-50">
  <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
    <div class="max-w-3xl mx-auto divide-y-2 divide-gray-200">
      <h2 class="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">
        Frequently asked questions
      </h2>
      <dl class="mt-6 space-y-6 divide-y divide-gray-200">
        <div
          v-for="faq of faqs"
          :key="faq.question"
          class="pt-6"
        >
          <dt class="text-lg">
            <!-- Expand/collapse question button -->
            <button type="button" @click="faq.open = !faq.open" class="text-left w-full flex justify-between items-start text-gray-400" aria-controls="faq-0" aria-expanded="false">
              <span class="font-medium text-gray-900">
                {{ faq.question }}
              </span>
              <span class="ml-6 h-7 flex items-center">
                <!--
                  Expand/collapse icon, toggle classes based on question open state.
                  Heroicon name: outline/chevron-down
                  Open: "-rotate-180", Closed: "rotate-0"
                -->
                <ChevronDownIcon
                  class="h-6 w-6 transform"
                  :class="[faq.open ? '-rotate-180' : 'rotate-0']"
                />
              </span>
            </button>
          </dt>
          <dd class="mt-2 pr-12 prose prose-sm" :class="{ 'hidden': !faq.open }" id="faq-0" v-html="faq.answer"></dd>
        </div>

        <!-- More questions... -->
      </dl>
    </div>
  </div>
</div>




<!-- This example requires Tailwind CSS v2.0+ -->
<div class="bg-white py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
  <div class="relative max-w-lg mx-auto divide-gray-200 lg:max-w-7xl">
    <div class="grid gap-16 lg:grid-cols-3 lg:gap-x-5">
      
      <tti-article-summary v-for="article in articles" :article="article" :key="article.url"></tti-article-summary>

    </div>
  </div>
</div>



<!-- 



<div class="bg-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="lg:text-center">
      <h2 class="text-lg text-gray-700 font-semibold tracking-wide">Have a question? We’d love to hear from you.</h2>
      <a href="mailto:hello@thetutorindex.com" class="mt-4 text-xl sm:text-3xl leading-8 font-bold tracking-tight text-blue-600 sm:text-4xl hover:underline">
        hello@thetutorindex.com
      </a>
    </div>
  </div>
</div>

 -->



<!-- This example requires Tailwind CSS v2.0+ -->
<div class="bg-indigo-200 bg-opacity-25">
  <div class="max-w-4xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
    <div class="lg:flex">
      <h2 class="max-w-md mx-auto text-3xl font-extrabold text-indigo-900 text-center lg:max-w-xl lg:text-left">
        Proud affiliate partner of The Tutors' Association
      </h2>
      <div class="flow-root self-center mt-8 lg:mt-0">
        <div class="-mt-4 -ml-8 flex flex-wrap justify-between lg:-ml-4">
          <div class="mt-4 ml-8 flex flex-grow flex-shrink-0 justify-center lg:flex-grow-0 lg:ml-4">
            <img class="h-20" src="../assets/the-tutor-association-logo.png" alt="The Tutor Index" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<tti-footer class="mt-12"></tti-footer>

</div>

</template>
<script>
import { SearchIcon, StatusOnlineIcon, CubeTransparentIcon, ChevronDownIcon } from '@vue-hero-icons/outline'
import ArticleService from '@/services/ArticleServices'
import TtiHeader from './HeaderNew'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SearchService from '@/services/SearchServices'
import CoffeeBreak from '@/components/Storyset/CoffeeBreak'
import InternationalCooperation from '../components/Storyset/InternationalCooperation.vue'

const articleService = new ArticleService()
const searchService = new SearchService()

const defaultSearchItems = [
  // { Type: 'SUBJECT', Id: 'MATHS', Description: 'Maths' },
  // { Type: 'SUBJECT', Id: 'ENGLISH', Description: 'English' },
]

export default {
    components: {
      'tti-footer': () => import('./Footer'),
      'tti-article-summary': () => import('./Article-Summary'),
      'heroicon': () => import('./Heroicon'),
      SearchIcon,
      TtiHeader,
      'VSelect': vSelect,
      StatusOnlineIcon,
      CubeTransparentIcon,
      ChevronDownIcon,
      CoffeeBreak,
      InternationalCooperation,
    },
    data() {
      return {
        articles: [],
        popularSearches: [
          { label: 'Maths', query: { s: 'MATHS' } },
          { label: 'English', query: { s: 'ENGLISH' } },
          { label: '11+', query: { l: '11PLUS' } },
          { label: 'Piano', query: { s: 'PIANO' } },
          { label: 'French', query: { s: 'FRENCH' } },
        ],
        initial: null,
        initialListItems: defaultSearchItems,
        faqs: [
          {
            question: 'How do I search for a tutor?',
            answer: `<p>First, enter a subject or level into the search bar and select whether you would like to see online tutors, and how far you’d be willing to travel if seeing a tutor in person. Online tutors will be shown by default unless you choose to set a location. Once on the search result page you can choose to only see tutors able to see you in person by toggling the ‘include tutors who teach online’ off.</p>`,
            open: false
          },
          {
            question: 'How do I contact a tutor? What happens when I contact a tutor?',
            answer: `<p>To contact a tutor, fill in the contact form at the bottom of the profile. Do try to include key details such as who the lessons are for, how much experience you/the student has. When you might be available, how often you would like lessons,  any specific goals you might have. Our tutors are encouraged to return your message within 48 hours.</p>`,
            open: false
          },
          {
            question: 'How can I be sure I’ve found a suitable tutor?',
            answer: `<p>All of the tutors on The Tutor Index have agreed to follow our safeguarding policy and code of conduct. We vet the quality of the tutor profiles to ensure that only those which are presentable and well-written are allowed to be displayed (did you know that only 1 in 4 profiles meet our standards).</p>
            <p>We encourage you to arrange an informal conversation with a tutor prior to engaging their services. You might also request to see copies of their qualifications, ID and or DBS check to ensure they are who they say they are.</p>`,
            open: false
          },
          {
            question: 'How do I pay a tutor?',
            answer: `<p>Tutors advertising on The Tutor Index are in charge of their own business and, as such, will have their own payment methods which they will arrange with you.</p>`,
            open: false
          },
        ]
      }
    },
    methods: {
      onInitialSelected(selectedItem) {
        let query = {}
        query[selectedItem.Type === 'SUBJECT' ? 's' : 'l'] = selectedItem.Id

        this.initial = null
        this.$router.push({ 
          name: 'SearchResults', 
          query
        })
      },
      async onInitialInput(searchStr, loadingCallback) {
        loadingCallback(true)
        var response = await searchService.initialSearch(searchStr.trim())
        loadingCallback(false)
        
        this.initialListItems = response.data.results[0]?.Levels || defaultSearchItems
      },
      focusOnSearch() {
        this.$refs.initialbox.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        this.$refs.initialbox.$refs.search.focus({ preventScroll: true })
      },
    },  
    async mounted() {
      this.articles = await articleService.getRecentArticles(1, 3);
    }
}
</script>
<style lang="scss">
.homepage-search {

  .vs__search, .vs__dropdown-toggle {
    margin: 0;
    padding: 0;
    width: 100%;
    border: none;
    box-shadow: none;
  }

  .vs__dropdown-menu {
    // position: absolute;
    // z-index: 10;
    // background-color: white;
    // width: 280px;
    transform: translateX(-16px) translateY(4px);
    // padding: 8px 16px;
    border-radius: 0 0 6px 6px;
    box-shadow: none;
    border: none;
  }

  .vs__dropdown-option {
    padding: 4px 16px;
  }

  .vs__open-indicator {
    display: none;
  }

  .vs__search::placeholder {
    color: revert;
  }

}
</style>